import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import moment from 'moment';
import {Colors} from '../../../../../domain/assistance/model/colors';
import {AgendaEvent} from '../../../../../domain/agenda/model/agenda-event';
import {EventCategoriesEnum} from '../../../../../domain/agenda/model/constante/event-categories.enum';
import {AgendaEventService} from '../../../../../domain/agenda/service/agenda-event.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatStepper} from '@angular/material/stepper';
import {LinkTypeEnum} from '../../../../../domain/agenda/model/link-type.enum';
import {EventPeriod} from '../../../../../domain/agenda/model/event-period';
import {Link} from '../../../../../domain/agenda/model/link';
import {getListAdvertise, getListSubscribe} from '../../../../../domain/agenda/agenda.util';
import {EventThemeEnum} from '../../../../../domain/agenda/model/constante/event-theme-enum';
import {AgendaSubjectEventService} from '../../../../../domain/agenda/service/agenda-subject-event.service';

@Component({
             selector: 'app-dialog',
             templateUrl: './create-event-dialog.component.html'
           })
export class CreateEventDialogComponent implements OnInit {

  categorySelected: any;
  themeSelected: any;
  title: string;
  description: string;
  place: string;
  startDate: Date;
  endDate: Date;
  programLink: string;
  subscriptionLink: string;
  commercialLink: string;
  colorSelected = Colors.insito;

  startDisplayDate: Date;
  endDisplayDate: Date;
  isFocus = false;

  newEvent = new AgendaEvent();
  editedEvent = new AgendaEvent();


  segmentationSolution = [
    {
      value: 'Dette',
      canSubscribe: false,
      tagSubscribe: 'insito-subscribe',
      canAdvertise: false,
      tagAdvertise: 'insito-advertise'
    },
    {
      value: 'Prospective',
      canSubscribe: false,
      tagSubscribe: 'inviseo-subscribe',
      canAdvertise: false,
      tagAdvertise: 'inviseo-advertise'
    },
    {
      value: 'Garantie',
      canSubscribe: false,
      tagSubscribe: 'alliance-subscribe',
      canAdvertise: false,
      tagAdvertise: 'alliance-advertise'
    },
    {
      value: 'Santé',
      canSubscribe: false,
      tagSubscribe: 'insito_sante-subscribe',
      canAdvertise: false,
      tagAdvertise: 'insito_sante-advertise'
    },
    {
      value: 'Habitat',
      canSubscribe: false,
      tagSubscribe: 'insito_habitat-subscribe',
      canAdvertise: false,
      tagAdvertise: 'insito_habitat-advertise'
    }
  ];

  isLinear = true;

  readonly categories = EventCategoriesEnum;
  readonly themes = EventThemeEnum;

  constructor(private formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<CreateEventDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private agendaService: AgendaEventService,
              private agendaSubjectEvent: AgendaSubjectEventService,
              public snackBar: MatSnackBar) {

    if (data != null) {
      this.categorySelected = data.event.category;
      this.themeSelected = data.event.theme;
      this.title = data.event.title;
      this.description = data.event.description;
      this.place = data.event.place;
      this.startDate = data.event.eventPeriod.startDate;
      this.endDate = data.event.eventPeriod.endDate;
      this.programLink = this.getProgramLink(data);
      this.commercialLink = this.getCommercialLink(data);
      this.subscriptionLink = this.getSubscriptionLink(data);
      this.colorSelected = data.event.color;
      this.isFocus = data.event.focus;
      this.startDisplayDate = data.event.displayPeriod.startDate;
      this.endDisplayDate = data.event.displayPeriod.endDate;
      this.segmentationSolution.filter(item => getListSubscribe(data.event.tags).indexOf(item.tagSubscribe) !== -1)
          .forEach(item => item.canSubscribe = true);
      this.segmentationSolution.filter(item => getListAdvertise(data.event.tags).indexOf(item.tagAdvertise) !== -1)
          .forEach(item => item.canAdvertise = true);
    } else {
      this.startDisplayDate = new Date();
    }
  }

  private getSubscriptionLink(data: any): string | undefined {
    return data.event.links.find(link => link.typeLink === LinkTypeEnum.SUBSCRIPTION_LINK)
           ? data.event.links.find(link => link.typeLink === LinkTypeEnum.SUBSCRIPTION_LINK).link
           : undefined;
  }

  private getProgramLink(data: any): string | undefined {
    return data.event.links.find(link => link.typeLink === LinkTypeEnum.PROGRAM_LINK)
           ? data.event.links.find(link => link.typeLink
                                           === LinkTypeEnum.PROGRAM_LINK).link
           : undefined;
  }

  private getCommercialLink(data: any): string | undefined {
    return data.event.links.find(link => link.typeLink === LinkTypeEnum.COMMERCIAL_LINK)
           ? data.event.links.find(link => link.typeLink
                                           === LinkTypeEnum.COMMERCIAL_LINK).link
           : undefined;
  }

  ngOnInit(): void {
  }

  setDates(newDate): void {
    this.startDate = newDate;
    this.endDisplayDate = new Date(newDate - 1);
    if (this.endDate == null) {
      this.endDate = newDate;
    }
  }

  goToStep2(stepper: MatStepper): void {
    if (this.checkFormOK()) {
      stepper.next();
    } else {
      this.openSnackBar();
    }
  }

  saveEvent(stepper: MatStepper): void {
    this.setValues(this.newEvent);
    this.newEvent.visible = true;
    if (this.checkFormOK()) {
      this.agendaService.addAgendaEvent(this.newEvent).subscribe(() => {
                                                                   this.agendaSubjectEvent.onChangeEvents.next();
                                                                   this.dialogRef.close();
                                                                 },
                                                                 error => console.error('Error while performing post...\n' + error));
    } else {
      stepper.reset();
      this.openSnackBar();
    }
  }

  editEvent(stepper: MatStepper, event: AgendaEvent): void {
    this.editedEvent.id = event.id;
    this.editedEvent.visible = true;
    this.setValues(this.editedEvent);
    if (this.checkFormOK()) {
      this.agendaService.editAgendaEvent(this.editedEvent).subscribe(() => {
                                                                       this.agendaSubjectEvent.onChangeEvents.next();
                                                                       this.dialogRef.close();
                                                                     },
                                                                     error => console.error('Error while performing put...\n' + error));
    } else {
      this.openSnackBar();
    }
  }

  setValues(event): void {
    event.title = this.title;
    event.description = this.description;
    event.place = this.place;
    event.eventPeriod = new EventPeriod();
    event.eventPeriod.startDate = this.transformMomentToDate(this.startDate);
    event.eventPeriod.endDate = this.transformMomentToDate(this.endDate);
    event.links = [new Link(this.programLink, LinkTypeEnum.PROGRAM_LINK),
                   new Link(this.subscriptionLink, LinkTypeEnum.SUBSCRIPTION_LINK),
                   new Link(this.commercialLink, LinkTypeEnum.COMMERCIAL_LINK)];
    if (this.categorySelected && this.themeSelected) {
      event.category = this.categorySelected;
      event.theme = this.themeSelected;
    }
    event.focus = this.isFocus;
    event.displayPeriod = new EventPeriod();
    event.displayPeriod.startDate = this.transformMomentToDate(this.startDate);
    event.displayPeriod.endDate = this.transformMomentToDate(this.endDate);
    event.tags = [];
    // tag advertise
    event.tags = event.tags.concat(this.segmentationSolution.filter(segment => segment.canAdvertise === true)
                                       .map(segment => segment.tagAdvertise));
    // tag subscribe
    event.tags = event.tags.concat(this.segmentationSolution.filter(segment => segment.canSubscribe === true)
                                       .map(segment => segment.tagSubscribe));
  }

  checkFormOK(): string {
    return (this.title
            && this.categorySelected
            && this.themeSelected
            && this.description
            && this.place
            && this.startDate
            && this.programLink
            && this.subscriptionLink
            && this.commercialLink);
  }


  openSnackBar(): void {
    this.snackBar.open('Veuillez remplir tous les champs pour enregistrer l\'événement', '', {
      duration: 4000,
      panelClass: ['snackbar', 'snackbar-error']
    });
  }

  private transformMomentToDate(dateAsMoment: any): string {
    const date = moment(dateAsMoment);
    return date.format('YYYY-MM-DD');
  }
}
